export const LUX_AI_SUBSCRIPTION_LINK = `https://luxhome.ai/products/luxstudio-only`
export const LUX_PLAY_SUBSCRIPTION_LINK = `https://luxhome.ai/products/luxstudio-and-luxplay`
